import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";
import Logo6 from "../../../images/location_new/caseimg/logo6.webp";
import Img6 from "../../../images/location_new/caseimg/img6.webp";
import Logo5 from "../../../images/location_new/caseimg/logo5.webp";
import Img5 from "../../../images/location_new/caseimg/img5.webp";
import Logo7 from "../../../images/location_new/caseimg/logo7.webp";
import Img7 from "../../../images/location_new/caseimg/img7.webp";
import Logo11 from "../../../images/location_new/caseimg/logo11.webp";
import Img11 from "../../../images/location_new/caseimg/img11.webp";

const CaseStudy = [
  {
    logo: Logo6,
    title: "The Idea Behind Teemates",
    description:
      "Teemates simplify the process of playing & engaging with fellow golf enthusiasts, offering a seamless and convenient platform, enabling you to connect with individuals sharing similar interests.",
    link: "teemates",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img6,
    BgColor: "#F7F7F7",
    TextColor: "#99B64B",
  },
  {
    logo: Logo5,
    title: "The Idea Behind PicturePick",
    description:
      "Picture Pick's grand vision is to combine an irresistible online game with cash prizes, offering an exciting dual experience that's impossible to resist.",
    link: "picture-pick",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img5,
    BgColor: "rgb(215 102 55 / 20%)",
    TextColor: "#d76637",
  },
  {
    logo: Logo7,
    title: "The Idea Behind Stop Vaping",
    description:
      "Stop Vaping, a digital teen solution, promotes reducing nicotine and e-cigarette use for better health. The app motivates and offers easy paths to a healthier lifestyle.",
    link: "stop-vaping",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img7,
    BgColor: "#66ccc14d",
    TextColor: "#febc5c",
  },
  {
    logo: Logo11,
    title: "The Idea Behind Button Smasher App",
    description:
      "An All-in-One Solution for Gamers. Stay Informed with Authentic Ratings and Gaming Industry News With Button Smasher Application.",
    link: "buttonsmasher",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img11,
    BgColor: "#6f429c80",
    TextColor: "#d8278b",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2>
                TekRevol’s Success Stories as a Top-Grade Game Development
                Company in UK{" "}
              </h2>
            </div>
            <p className="z_idx">
              The success stories of TekRevol vividly demonstrate the excellence
              of our game development services. We have collaborated with
              businesses and entrepreneurs across diverse industries, aiding
              them in the realization of their business objectives. Here are
              some of the projects we’ve successfully created as one of the
              bespoke UK game studios:
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link
                          ? `/case-studies/${item.link}`
                          : "https://www.tekrevol.com/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
